module.exports = __webpack_public_path__ + "img/arms.04616c86.png";